<!--
Element that visually resembles an IonSelect, but does not have the functionality of one.
(this is used elsewhere where we want to use a custom interface for a select, like in SelectModal)
-->
<template>
	<div class="fake-ion-select flex h-full w-full items-center py-2">
		<div
			class="flex h-12 w-full flex-row items-center justify-between overflow-x-clip px-0.5"
		>
			<div class="flex min-w-0 flex-1 flex-col gap-1 truncate">
				<div class="fake-ion-select-label text-xs">
					{{ label }}
				</div>
				<div
					class="fake-ion-select-value min-w-0 truncate"
					:class="{ 'opacity-50': !selectElementText }"
				>
					<slot>
						{{ selectElementText ?? placeholder }}
					</slot>
				</div>
			</div>

			<ion-icon
				class="flex-shrink-0 text-base text-gray-600"
				:icon="caretDownOutline"
			/>
		</div>
		<div v-if="props.error" class="pl-1 pt-0.5 text-xs text-red-600">
			{{ props.error }}
		</div>
	</div>
</template>

<script setup lang="ts">
	import { IonIcon } from "@ionic/vue";
	import { caretDownOutline } from "ionicons/icons";

	interface FakeIonSelectProps {
		/** Label for the select element */
		label?: string;
		/** Text to show in the "selected value" part of the element */
		selectElementText?: string;
		/** Text to show if no value */
		placeholder?: string;
		/** Error message to display below the select */
		error?: string;
	}

	const props = defineProps<FakeIonSelectProps>();
</script>
